<template>
  <v-container>
    <Profile />
  </v-container>
</template>

<script>
import Profile from '@components/profile';

export default {
  name: 'Account',
  components: {
    Profile,
  },
};
</script>
